/**
 * Authorization Roles
 */
const authRoles = {
  admin: ["admin"],
  supporter: ["admin", "supporter"],
  user: ["admin", "supporter", "user"],
  onlyGuest: [],
};

export default authRoles;
